import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Environment, EnvironmentService } from '@web/service';
import { localeUtils } from '@nestech/utils';
import { cassiopeiaIcons } from '@nestech/utils';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

const getPhone = (environment: Environment): string => {
  const language = localeUtils.getLanguage();
  let phone = environment.contactInfo.phone;
  if (language === 'da') {
    phone = phone.replaceAll('+45', '');
  }
  return phone.trim();
};

@Component({
  selector: 'cas-top-navigation-phone',
  template: `
    <a
      class="d-flex btn align-items-center"
      [href]="'tel://' + tel">
      <fa-icon
        class="text-primary"
        [icon]="icons.phone"
        [fixedWidth]="true"></fa-icon>
      <span class="d-none d-md-inline fs-sm fw-medium ms-1 text-primary">{{ phone }}</span>
    </a>
  `,
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavigationPhoneComponent {
  #environment = inject(EnvironmentService).environment;

  icons = cassiopeiaIcons;
  tel = this.#environment.contactInfo.phone;
  phone = getPhone(this.#environment);
}
